import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";

export const InvoiceCorrectionFormActions = ({ onSave, isPending = false }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const handleCancel = () => {
    navigate(-1);
  };

  return (
    <div className="sticky left-0 top-16 z-10 w-full bg-grayLightMainBg">
      <div className="flex justify-between pt-8 pb-0 md:py-8 items-center flex-wrap">
        <div className="w-full md:w-5/12 text-2xl md:text-4xl pb-2 md:pb-0">
          {t("invoices:correction_create_title")}
        </div>
        <div className="flex gap-2">
          <Button
            variant="outline"
            onClick={handleCancel}
            disabled={isPending}
          >
            {t("common:button_cancel")}
          </Button>
          <Button
            className="text-blueText bg-blueLightAccent hover:bg-blueLightAccent border-[1px] border-blueBorder shadow-none"
            disabled={isPending}
            onClick={onSave}
          >
            {t("common:button_save")}
          </Button>
        </div>
      </div>
    </div>
  );
};
